import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ResolvedCategoryConfigurationDto } from '@rocksoft/settings-sdk';

export type CategoryResolvedConfigurationState = EntityState<ResolvedCategoryConfigurationDto>;

export function selectId(configuration: ResolvedCategoryConfigurationDto) {
  return configuration.categoryId ?? '';
}

export const adapter: EntityAdapter<ResolvedCategoryConfigurationDto> =
  createEntityAdapter<ResolvedCategoryConfigurationDto>({
    selectId,
  });

export const initialState: CategoryResolvedConfigurationState = adapter.getInitialState();
